import axios from "@/plugins/axios";

let url = "/api/v1/person/recruitment-applications";

export default {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    revoke(data) {
        return axios.post(`${url}/${data._id}/revoke`).then((result) => result.data);
    },
};
